import { render, staticRenderFns } from "./CapNhatVaiTro.vue?vue&type=template&id=a8b27710&"
import script from "./CapNhatVaiTro.vue?vue&type=script&lang=js&"
export * from "./CapNhatVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports